import { useWatch } from "react-hook-form";
import { useIntl } from "react-intl";

import { ScheduleStopValue } from "@RequestFormV2/defaults/scheduleDefaults";
import {
  getPickupDateTime,
  isDeadlineAfterPickup,
} from "@RequestFormV2/sections/Provider/utils/exceedsPickupDeadline";

export function usePickupExceedsWarningMessage(
  pickupExceedsWarning: "quoting" | "confirmation" | undefined,
  dateName: string,
  timeName: string,
): string | undefined {
  const intl = useIntl();
  const deadlineDate = useWatch({ name: dateName });
  const deadlineTime = useWatch({ name: timeName });
  const stops = useWatch({ name: "schedule.stops" }) as ScheduleStopValue[] | undefined;

  if (!pickupExceedsWarning) return undefined;

  const pickupDateTime = getPickupDateTime(stops);
  const showWarning =
    deadlineDate &&
    pickupDateTime &&
    isDeadlineAfterPickup(deadlineDate, deadlineTime, pickupDateTime.date, pickupDateTime.time);

  if (!showWarning || !pickupDateTime) return undefined;

  return intl.formatMessage(
    {
      id:
        pickupExceedsWarning === "quoting"
          ? "request-form.provider.deadlines.quotingExceedsPickup"
          : "request-form.provider.deadlines.confirmationExceedsPickup",
      defaultMessage:
        pickupExceedsWarning === "quoting"
          ? "The suggested quoting deadline exceeds the requested pickup date. ({date})"
          : "The suggested confirmation time exceeds the requested pickup date. ({date})",
    },
    { date: pickupDateTime.date },
  );
}
